export default __webpack_public_path__ + "static/media/icon-server.7b731bce.svg";